import type { LucideProps } from 'lucide-react'
import * as React from 'react'
import { forwardRef } from 'react'

export interface FaveIconProps extends LucideProps {
  filled?: boolean
}

export const FaveIcon = forwardRef<SVGSVGElement, FaveIconProps>(
  ({ size = 24, color = 'currentColor', filled, ...props }, ref) => {
    return (
      <svg
        ref={ref}
        width={size}
        height={size}
        viewBox='0 0 24 21'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
        {...props}
      >
        {filled && (
          <path
            d='M12.025 21C11 20 0.4 12.2 0.4 5.5C0.4 2.5 2.5 0.1 5.3 0.1C7 0.1 8.7 1 10 2.6L12.025 5.1L14.05 2.6C15.35 1 17.05 0.1 18.75 0.1C21.55 0.1 23.65 2.5 23.65 5.5C23.65 12.2 13.05 20 12.025 21Z'
            fill={color}
          />
        )}
        <path
          d='M12.0306 20.9993H12.0208C12.0224 20.9993 12.0241 20.9983 12.0257 20.9983C12.0272 20.9983 12.0291 20.9993 12.0306 20.9993ZM4.7757 0.175045C6.04987 -0.158383 7.36132 -0.0154676 8.66339 0.603755C9.75148 1.11818 10.7006 1.87063 11.4818 2.8518C11.5747 2.966 11.6676 3.08012 11.7698 3.18481C11.8442 3.261 11.9464 3.28953 12.0208 3.29907C12.1137 3.29907 12.1974 3.25185 12.2718 3.16626L12.5511 2.84204C12.7463 2.60404 12.9506 2.37546 13.1644 2.15649C14.5315 0.746566 16.1413 0.0314899 17.9456 0.0314899H18.0198C19.9914 0.0505898 21.6284 0.965269 22.7444 2.67993C23.6001 3.99459 24.0003 5.47167 24.0003 7.32934C24.0003 8.91061 23.5351 10.5206 22.6517 11.9875C20.6242 15.3313 18.0757 17.9992 15.0716 19.9045C14.5415 20.2379 13.9923 20.4852 13.4622 20.7043C12.9988 20.9037 12.5169 20.9977 12.0257 20.9983C11.4132 20.9976 10.7728 20.8461 10.1234 20.5325C8.75633 19.8847 7.42639 18.9609 6.06866 17.7131C4.22716 16.0174 2.6645 14.1309 1.43683 12.1018C-0.023326 9.69161 -0.376636 7.14783 0.404602 4.54711C1.09286 2.2514 2.60882 0.737115 4.7757 0.175045ZM6.13312 1.94653C5.83562 1.94654 5.53804 1.98463 5.24054 2.06079C3.69665 2.4609 2.71054 3.46201 2.20831 5.12915V5.11938C1.59456 7.16749 1.87394 9.17729 3.03644 11.092C4.1711 12.9592 5.61272 14.7125 7.33331 16.2844C8.55158 17.3989 9.72348 18.2178 10.9232 18.7893C11.6114 19.1132 12.1972 19.1613 12.7552 18.9231C13.2016 18.7326 13.6761 18.5231 14.0853 18.2659C16.8754 16.4939 19.1538 14.1022 21.0511 10.968C21.7392 9.8249 22.1204 8.53911 22.1204 7.32934C22.1204 5.87185 21.8324 4.73828 21.1907 3.75708C20.4095 2.56626 19.3767 1.97559 18.0189 1.96606H17.9632C16.6612 1.96613 15.5267 2.47095 14.513 3.51879C14.327 3.70932 14.1501 3.9098 13.9827 4.11938L13.6849 4.47094C13.2664 4.94727 12.6991 5.22435 12.0853 5.2434C11.4622 5.2243 10.8949 5.01409 10.4485 4.55688C10.2999 4.40462 10.1699 4.2428 10.0306 4.07153C9.43537 3.32849 8.71863 2.74751 7.89093 2.36645C7.2864 2.08066 6.70975 1.94653 6.13312 1.94653Z'
          fill={color}
        />
      </svg>
    )
  },
)

FaveIcon.displayName = 'FaveIcon'
